export default __webpack_public_path__ + "static/media/default_billboard.fce3caca.png";